export default (lastGigInCookie, userWasLoggedIn) => !!lastGigInCookie && !userWasLoggedIn;
